<template>
  <div
    class="bill-change-manage-bd tb"
    v-if="funcView.invoiceBody_open_list || funcView.invoiceBody_receive_list"
  >
    <custom-tab
      :list="tabData"
      v-model="tabIndex"
      :fixBorder="true"
    ></custom-tab>
    <div
      class="container"
      v-if="tabIndex===0 && funcView.invoiceBody_open_list"
    >
      <!-- 开票方 -->
      <body-table v-if="infoType === 0"></body-table>
    </div>
    <div
      class="container"
      v-if="tabIndex === 1 && funcView.invoiceBody_receive_list"
    >
      <!-- 受票方 -->
      <recipient-table></recipient-table>
    </div>

  </div>
</template>

<script>
// import apis from '@/utils/apis';
import bodyTable from './children/body-table.vue';
import recipientTable from './children/recipient-table.vue';


export default {
  name: 'bill_change_manage',
  components: { bodyTable, recipientTable },
  data() {
    return {
      provide: true,
      tabIndex: 0,
      infoType: 0
    };
  },
  computed: {
    tabData() {
      const ret = [
      ];
      if (this.funcView.invoiceBody_open_list) {
        ret.push({
          name: this.$t('fms_invoiceBody.kai_piao_fang'),
          value: 0
        });
      }
      if (this.funcView.invoiceBody_receive_list) {
        ret.push({
          name: this.$t('fms_invoiceBody.shou_piao_fang'),
          value: 1
        });
      }

      return ret;
    }
  },
  mounted: function () {

    this.getFuncView('/invoice/invoiceBody');
  },
  methods: {
    // // 获取表格数据
    // getTableList: function () {
    //   this.$getJSON(apis.page, this.formSearch).then((res) => {
    //     this.tableList = res.data.list;
    //     this.totalRows = res.data.total;
    //   });
    // },
    // // 分页变更
    // onPageChange: function ({ page, size }) {
    //   this.formSearch.pageNum = page;
    //   this.formSearch.pageSize = size || this.formSearch.pageSize;
    //   this.getTableList();
    // }
  }
};
</script>

<style lang="scss">
.bill-change-manage-bd {
  padding-left: 0 !important;

  > .container {
    padding-left: 16px;
    flex: 1;
    overflow: hidden;
  }
}
</style>
